<template>
  <nav aria-label="Breadcrumb" class="flex items-center space-x-2">
    <ol class="inline-flex flex-wrap items-center space-x-1 md:space-x-1">
      <li v-for="(section, index) in breadCrumbSections" :key="index" class="inline-flex items-center flex-shrink-0">
        <template v-if="section.href">
          <a
            v-if="index == 0"
            href="/"
            class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
          >
            <img
              name="icon"
              :src="index == 0 ? '/img/icons/home.svg' : '/img/icons/chevron_right.svg'"
              alt="icon"
              class="w-5 h-5 dark:invert dark:invert-1"
            />
            <!-- Place icon here -->
            <span class="text-lg break-words ml-1">{{ section.name }}</span>
          </a>
          <NuxtLinkLocale
            v-else
            :to="index == 0 ? '/' : section.href"
            class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
          >
            <img
              name="icon"
              :src="index == 0 ? '/img/icons/home.svg' : '/img/icons/chevron_right.svg'"
              alt="icon"
              class="w-5 h-5 dark:invert dark:invert-1"
            />
            <!-- Place icon here -->
            <span class="text-lg break-words ml-1">{{ section.name }}</span>
          </NuxtLinkLocale>
        </template>
        <template v-else>
          <span class="inline-flex items-center text-sm font-medium text-gray-500 dark:text-gray-400">
            <img name="icon" src="/img/icons/chevron_right.svg" alt="icon" class="w-5 h-5 dark:invert dark:invert-1" />
            <!-- Place icon here -->
            <span class="text-lg break-words ml-1">{{ section.name }}</span>
          </span>
        </template>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Utility from '~/server/utils/utils';
import type { BreadCrumb } from '~/types';

const route = useRoute();
const localePath = useLocalePath();
const { t } = useI18n();

//Based on the current url show the breadcrumb
let URLVars = Utility.scomposeURL(route.path).segments;
const breadCrumbSections = ref<BreadCrumb[]>([]);

// Iterate through the URLVars to build the breadcrumb sections
URLVars.forEach((varObj, index) => {
  if (index === 0) {
    // Add the home section
    breadCrumbSections.value.push({ name: t('Home'), url: '/', href: '#' });
  }
  // Add the breadcrumb section, if it is not the last section
  if (index < URLVars.length - 1) {
    breadCrumbSections.value.push({ name: varObj.displayName, url: varObj.link, href: varObj.link });
  } else {
    breadCrumbSections.value.push({ name: varObj.displayName, url: varObj.link, href: null });
  }
});
</script>
